import { render } from "./rtl-project-table.vue?vue&type=template&id=74f6afcc"
import script from "./rtl-project-table.vue?vue&type=script&lang=js"
export * from "./rtl-project-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__